import localforage from 'localforage'
import axios from 'axios'
export const navbar = {
    state: {
        isNavbarHidden: false,
        isLoadingPdf: false
    },
    mutations: {
        HIDE_NAVBAR(state, isNavbarHidden) {
            state.isNavbarHidden = isNavbarHidden
        },
        SET_LOADING_PDF(state, status){
            state.isLoadingPdf = status
        }
    },
    actions: {
        hideNavbar({ commit }, payload) {
            commit('HIDE_NAVBAR', payload)
        },
        setLoadingPdf({ commit }, payload) {
            commit('SET_LOADING_PDF', payload)
        },
        fetchDemandsPdf({ commit, state, dispatch }, payload) {
            // prevent multiple requests at same time
            if(state.isLoadingPdf === true)
                return
            commit('SET_LOADING_PDF', true)
            return localforage.getItem('authUser').then((headers) => {
                return axios.post( process.env.VUE_APP_API+'demands', {
                    browser_data: {user_agent: navigator.userAgent, platform: navigator.platform, app_number: process.env.PACKAGE_VERSION}
                },{
                    headers: JSON.parse(headers),
                    responseType: 'arraybuffer',
                    validateStatus: function (status) {
                        return status < 500; // Resolve only if the status code is less than 500
                    }
                })
                    .then(response => {
                        if(response.status === 200) {
                            const file = new Blob([response.data], { type: 'application/pdf' })
                            const fileURL = URL.createObjectURL(file)
                            const link = document.createElement('a')
                            link.href = fileURL
                            link.download = `Zapotrzebowanie.pdf`
                            link.click()
                            link.remove()
                        }
                        else if(response.status === 404) {
                            dispatch('addNotification', {
                                type: 'danger',
                                title: 'Nie udało się pobrać zapotrzebowania',
                                content: `Nie znaleziono żadnych dostaw. Zapotrzebowanie dzienne generowane jest zawsze na dzień bieżący.`
                            })
                        }
                        else {
                            dispatch('addNotification', {
                                type: 'danger',
                                title: 'Nie udało się pobrać zapotrzebowania',
                                content: `Błędna odpowiedź serwera: ${response.status}`
                            })
                        }
                        commit('SET_LOADING_PDF', false)
                    }).catch(error => {
                        commit('SET_LOADING_PDF', false)
                        dispatch('addNotification', {
                            type: 'danger',
                            title: 'Nie udało się pobrać zapotrzebowania',
                            content: `Błędna odpowiedź serwera: ${error.response.status}`
                        })
                    })
            })
        }
    },
    getters: {
        isNavbarHidden: (state) => {
            return state.isNavbarHidden
        },
        isLoadingPdf: (state) => {
            return state.isLoadingPdf
        }
    }
}
